import { render } from "./EmployeePageList.vue?vue&type=template&id=24989027&scoped=true"
import script from "./EmployeePageList.vue?vue&type=script&lang=ts"
export * from "./EmployeePageList.vue?vue&type=script&lang=ts"

import "./EmployeePageList.vue?vue&type=style&index=0&id=24989027&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-24989027"

export default script